import { Node } from "@tiptap/core";
import {
  NodeViewContent,
  NodeViewWrapper,
  ReactNodeViewRenderer,
} from "@tiptap/react";
import { useRouter } from "next/router";

import { GRAPHIC_ORGANIZER_PARAM } from "@/components/AIComponents/ExportablesModal";
import { getUrlFromNodeAttrs } from "@/view/ContentDisplay/TeacherTools/LessonPlannerTool/LessonPlan/utils";
import { ComponentProps } from "@/view/TiptapArticleBody/TiptapArticleBody.interface";

export const GRAPHIC_ORGANIZER_NODE_TYPE = "graphic_organizer_link";

const GraphicOrganizerComponent = ({ node }: ComponentProps) => {
  const router = useRouter();
  const url = getUrlFromNodeAttrs(node);

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault();

    const paramsFromHref = new URLSearchParams(url.search);
    const graphicOrganizer = paramsFromHref.get(GRAPHIC_ORGANIZER_PARAM);
    const { pathname, query } = router;
    const newQuery = {
      ...query,
      [GRAPHIC_ORGANIZER_PARAM]: graphicOrganizer,
    };

    router.replace({ pathname, query: newQuery }, undefined, { shallow: true });
  };

  return (
    <NodeViewWrapper as="a" href={url.toString()} onClick={handleClick}>
      <NodeViewContent as="span" />
    </NodeViewWrapper>
  );
};

export const GraphicOrganizerLink = Node.create({
  name: GRAPHIC_ORGANIZER_NODE_TYPE,
  inline: true,
  group: "inline",
  atom: false,
  content: "text*",

  addAttributes() {
    return {
      href: {
        default: null,
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", HTMLAttributes, 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(GraphicOrganizerComponent);
  },
});
